import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import Form from "@common/externos/components/validation/form.validation";
import decaSelector from "../store/deca.selectors";
import autoBind from "react-autobind";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  get initialValues() {
    return {};
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "DECA" });
  }

  render() {
    const { title, onSubmit, onCancel, prefix, children } = this.props;
    const { deca } = this.props.decaSelector;
    const isView = prefix == "V";

    return (
      <Form
        onSubmit={onSubmit}
        boxForm
        onCancel={onCancel || this.onCancel}
        initialValues={this.initialValues}
        prefix={prefix}
        title={title}
        formControl={true}
      >
        {form => <Fragment>{children}</Fragment>}
      </Form>
    );
  }
}

export default connect({
  selectors: {
    decaSelector
  }
})(Container);
